var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('notifications',{attrs:{"position":"top right","max":3,"speed":500}}),_c('notifications',{attrs:{"group":"info","position":"top center","max":3,"classes":"alert  alert-primary rounded  p-5","speed":500,"width":400}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }